import { render, staticRenderFns } from "./newMainWindow.vue?vue&type=template&id=7d462539&scoped=true"
import script from "./newMainWindow.vue?vue&type=script&lang=js"
export * from "./newMainWindow.vue?vue&type=script&lang=js"
import style0 from "./newMainWindow.vue?vue&type=style&index=0&id=7d462539&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d462539",
  null
  
)

export default component.exports